// Import the axios library to handle HTTP requests
// Create a new axios instance with a pre-configured base URL
// All HTTP requests made using this 'api' instance will automatically use the base URL 'http://localhost:8000'
// This allows us to make requests like `api.get('/endpoint')` instead of repeating the full URL
// Export the 'api' instance so it can be used in other parts of the application for making HTTP requests

import axios from "axios";

// Adjust baseURL as needed for your deployment
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'
});

api.interceptors.response.use(
  response => response,
  error => {
    // Only handle errors with a response (not network or CORS errors)
    if (error.response && error.response.status === 401) {
      const reason = error.response.data?.reason;

      // Customize UX based on reason from backend
      if (reason === "membership_expired") {
        // Redirect to membership renewal page
        window.location.href = "/renew-membership";
      } else if (reason === "banned") {
        // Redirect to banned account info page
        window.location.href = "/banned";
      } else {
        // Default: token expired or generic unauthorized
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        // Optionally clear any other sensitive storage
        window.location.href = "/login?expired=1";
      }
    }

    // Optional: handle other status codes globally here if needed
    // if (error.response && error.response.status === 403) { ... }

    // Always return the error to be caught by calling code if needed
    return Promise.reject(error);
  }
);

export default api;
